export default __webpack_public_path__ + "static/media/dealer-4.85395883.png";